import {
  ErrorResponseErrorItemCodeAccount,
  ErrorResponseErrorItemCodeAccountUserRequest,
  ErrorResponseErrorItemCodeAssetTag,
  ErrorResponseErrorItemCodeAuth,
  ErrorResponseErrorItemCodeBatchDownload,
  ErrorResponseErrorItemCodeComment,
  ErrorResponseErrorItemCodeCommon,
  ErrorResponseErrorItemCodeCompany,
  ErrorResponseErrorItemCodeCoordinateSystem,
  ErrorResponseErrorItemCodeDongle,
  ErrorResponseErrorItemCodeDynamicAsset,
  ErrorResponseErrorItemCodeExternalSource,
  ErrorResponseErrorItemCodeFile,
  ErrorResponseErrorItemCodeFileVersion,
  ErrorResponseErrorItemCodeFolder,
  ErrorResponseErrorItemCodeGeodata,
  ErrorResponseErrorItemCodeGeoid,
  ErrorResponseErrorItemCodeIntegrationKey,
  ErrorResponseErrorItemCodeLicense,
  ErrorResponseErrorItemCodeOrthotile,
  ErrorResponseErrorItemCodePoi,
  ErrorResponseErrorItemCodePointCloud,
  ErrorResponseErrorItemCodeProject,
  ErrorResponseErrorItemCodeSharedFolder,
  ErrorResponseErrorItemCodeSharedView,
  ErrorResponseErrorItemCodeSkyMapConnect,
  ErrorResponseErrorItemCodeSkyMapImage,
  ErrorResponseErrorItemCodeSubscription,
  ErrorResponseErrorItemCodeTag,
  ErrorResponseErrorItemCodeTiledModel,
  ErrorResponseErrorItemCodeTimelineContainer,
  ErrorResponseErrorItemCodeUser,
} from '../../../../../typings/api/skymap/rest/v1/.common';
import { translations as accountTranslations } from './account';
import { translations as accountUserRequestTranslations } from './account-user-request';
import { translations as assetTagTranslations } from './asset-tag';
import { translations as authTranslations } from './auth';
import { translations as batchDownloadTranslations } from './batch-download';
import { translations as commentTranslations } from './comment';
import { translations as commonTranslations } from './common';
import { translations as companyTranslations } from './company';
import { translations as coordinateSystemTranslations } from './coordinate-system';
import { translations as dongleTranslations } from './dongle';
import { translations as dynamicAssetTranslations } from './dynamic-assets';
import { translations as externalSourceTranslations } from './external-source';
import { translations as fileTranslations } from './file';
import { translations as fileVersionTranslations } from './file-version';
import { translations as folderTranslations } from './folder';
import { translations as geodataTranslations } from './geodata';
import { translations as geoidTranslations } from './geoid';
import { translations as integrationTranslations } from './integration';
import { ErrorResponseErrorItemCodeLeica, translations as leicaTranslations } from './leica';
import { translations as licenseTranslations } from './license';
import { translations as orthotileTranslations } from './orthotile';
import { translations as poiTranslations } from './poi';
import { translations as pointCloudTranslations } from './point-cloud';
import { translations as projectTranslations } from './project';
import { translations as sharedFolderTranslations } from './shared-folder';
import { translations as sharedViewTranslations } from './shared-view';
import { translations as skymapConnectTranslations } from './skymap-connect';
import { translations as skyMapImageTranslations } from './skymap-image';
import { translations as subscriptionTranslations } from './subscription';
import { translations as tagTranslations } from './tag';
import { translations as tiledModelTranslations } from './tiled-model';
import { translations as timelineContainerTranslations } from './timeline-container';
import { translations as userTranslations } from './user';
import { ErrorResponseErrorItemCodeXsite, translations as xsiteTranslations } from './xsite';

export type ErrorResponseErrorItemCode =
  | ErrorResponseErrorItemCodeAccount
  | ErrorResponseErrorItemCodeAccountUserRequest
  | ErrorResponseErrorItemCodeAuth
  | ErrorResponseErrorItemCodeBatchDownload
  | ErrorResponseErrorItemCodeComment
  | ErrorResponseErrorItemCodeCommon
  | ErrorResponseErrorItemCodeCompany
  | ErrorResponseErrorItemCodePointCloud
  | ErrorResponseErrorItemCodeOrthotile
  | ErrorResponseErrorItemCodeCoordinateSystem
  | ErrorResponseErrorItemCodeDongle
  | ErrorResponseErrorItemCodeDynamicAsset
  | ErrorResponseErrorItemCodeExternalSource
  | ErrorResponseErrorItemCodeFile
  | ErrorResponseErrorItemCodeFileVersion
  | ErrorResponseErrorItemCodeFolder
  | ErrorResponseErrorItemCodeGeodata
  | ErrorResponseErrorItemCodeGeoid
  | ErrorResponseErrorItemCodeIntegrationKey
  | ErrorResponseErrorItemCodeLeica
  | ErrorResponseErrorItemCodeLicense
  | ErrorResponseErrorItemCodeProject
  | ErrorResponseErrorItemCodePoi
  | ErrorResponseErrorItemCodeSharedFolder
  | ErrorResponseErrorItemCodeSharedView
  | ErrorResponseErrorItemCodeSkyMapConnect
  | ErrorResponseErrorItemCodeSkyMapImage
  | ErrorResponseErrorItemCodeSubscription
  | ErrorResponseErrorItemCodeTag
  | ErrorResponseErrorItemCodeTiledModel
  | ErrorResponseErrorItemCodeTimelineContainer
  | ErrorResponseErrorItemCodeUser
  | ErrorResponseErrorItemCodeXsite
  | ErrorResponseErrorItemCodeAssetTag;

//
// Note: Translations are rebuilt on each call so each module can read the current i18next
// language. Every module falls back to Swedish if i18next has not been initialized.
//
export const translations = (): Record<ErrorResponseErrorItemCode, string> => ({
  ...accountTranslations(),
  ...accountUserRequestTranslations(),
  ...assetTagTranslations(),
  ...authTranslations(),
  ...batchDownloadTranslations(),
  ...commentTranslations(),
  ...commonTranslations(),
  ...companyTranslations(),
  ...coordinateSystemTranslations(),
  ...dongleTranslations(),
  ...dynamicAssetTranslations(),
  ...externalSourceTranslations(),
  ...fileTranslations(),
  ...fileVersionTranslations(),
  ...folderTranslations(),
  ...geodataTranslations(),
  ...geoidTranslations(),
  ...integrationTranslations(),
  ...leicaTranslations(),
  ...licenseTranslations(),
  ...orthotileTranslations(),
  ...poiTranslations(),
  ...pointCloudTranslations(),
  ...projectTranslations(),
  ...sharedFolderTranslations(),
  ...sharedViewTranslations(),
  ...skymapConnectTranslations(),
  ...skyMapImageTranslations(),
  ...subscriptionTranslations(),
  ...tagTranslations(),
  ...tiledModelTranslations(),
  ...timelineContainerTranslations(),
  ...userTranslations(),
  ...xsiteTranslations(),
});
